import { Component, Input } from '@angular/core';

@Component({
  selector: 'jazzmo-tag',
  template: ` <a routerLink="/search" [queryParams]="{ tag: value }">{{ value }}</a> `,
})
export class TagComponent {
  @Input() value = '';
}
